// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"creditcard-off","clipPath":"url(#clip0_543_8010)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.001 10.0019H16.001L16 10.0009L17.001 10.0019ZM17.001 10.0019L22 10.001M22 10.001L22.001 10.0019L22 9.00096M22 10.001V9.00096M22 10.001V15.001M22 15.001V16.001L22.001 16.0019L22 15.001ZM11.001 4.00195H10.001L10 4.00095L11.001 4.00195ZM11.001 4.00195L22 4.00097V9.00096M6 15H9M2 10H9M4 4L2 4V20H20L4 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 22L2 2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CreditcardOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'creditcard-off',
    ref,
    icon: element,
  },
));

CreditcardOffIcon.displayName = 'CreditcardOffIcon';

export default CreditcardOffIcon;
